import React from 'react'
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from '../Pages/Home';
import SignIn from '../Pages/SignIn';
import ResetPassword from '../Pages/ResetPassword';
import SignUp from '../Pages/SignUp';
import Dashboard from '../Components/Dashboard/dashboard';
import Customer from '../Components/Customer/Customer';
import Profile from '../Components/Profile/Profile';
import Billing from '../Components/Billing/Billing';
import CustomerInfo from '../Components/CustomerInfo/CustomerInfo';
import Products from '../Components/Products/Products';
import CreateInvoice from '../Components/CreateInvoice/CreateInvoice';
import AddProduct from '../Components/AddProduct/AddProduct';
import EditProduct from '../Components/EditProduct/EditProduct';
import ProductDetail from '../Components/ProductDetail/ProductDetail';
import ProductPriceDetail from '../Components/ProductPriceDetail/ProductPriceDetail';
import CreateCoupon from '../Components/CreateCoupon/CreateCoupon';
import CouponDetails from '../Components/CouponDetails/CouponDetails';
import ShiprateDetail from '../Components/ShiprateDetail/ShiprateDetail';
import ActivePayment from '../Components/ActivePayment/ActivePayment';
import Reports from '../Components/Reports/Reports';


const Routers = () => {
    return (
        <Router>
            <Routes>
                <Route path='/' element={<Home />} />
                <Route path='/signIn' element={<SignIn />} />
                <Route path='/resetPassword' element={<ResetPassword />} />
                <Route path='/signUp' element={<SignUp />} />
                <Route path='/dashboard' element={<Dashboard />} />
                <Route path='/customers' element={<Customer />} />
                <Route path='/customers/:id' element={<CustomerInfo />} />
                <Route path='/setting/user' element={<Profile />} />
                <Route path='/billing' element={<Billing />} />
                <Route path='/product' element={<Products />} />
                <Route path='/billing/create' element={<CreateInvoice />} />
                <Route path='/product/create' element={<AddProduct />} />
                <Route path='/product/edit' element={<EditProduct />} />
                <Route path='/product/:id' element={<ProductDetail />} />
                <Route path='/product/price-detail/:id' element={<ProductPriceDetail />} />
                <Route path='/product/coupon/create' element={<CreateCoupon />} />
                <Route path='/product/coupon/123' element={<CouponDetails />} />
                <Route path='/product/shipping-rate/123' element={<ShiprateDetail />} />
                <Route path='/active-payment' element={<ActivePayment />} />
                <Route path='/reports' element={<Reports />} />
            </Routes>
        </Router>
    )
}

export default Routers